import { render, staticRenderFns } from "./OurUserGuideButton.vue?vue&type=template&id=8645b47c&"
import script from "./OurUserGuideButton.vue?vue&type=script&lang=js&"
export * from "./OurUserGuideButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports